export default "__VITE_ASSET__BhctZwcd__"